export default {
  // 付款单查询
  LIST_FUND_PAYMENT_BY_PAGE: '/financial/fundPayment/listFundPaymentByPage',
  // 详情
  PAYMENT_DETAIL: '/financial/fundPayment/detail',
  // 创建付款单详情
  PAYMENT_CREATE_DETAIL: '/financial/paymentApply/createPayment',
  // 删除
  PAYMENT_DELETE: '/financial/fundPayment/delete',
  // 批量生成凭证
  GENERATE_CREDENTIALS: '/financial/fundPayment/generateCredentials',
  //  生成凭证
  GENERATE_CREDENTIAL: '/financial/fundPayment/generateCredential',
  // 冲销
  REVERSE: '/financial/fundPayment/reverse',
  // 修改
  PAYMENT_UPDATE: '/financial/fundPayment/update',
  // 确认付款
  CONFIRM_PAYMENT: '/financial/fundPayment/confirmPayment',
  // 字典表查询
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 导出
  EXPORT_FUND_PAYMENT: '/financial/fundPayment/exportFundPayment',
  // 创建
  PAYMENT_SAVE: '/financial/fundPayment/save',
  // 查询付款单行号
  LIST_PAYMENT_DELTAIL_BY_PAGE: '/financial/fundPayment/listFundPaymentDetailPage',
  // 付款单导出
  EXPORT_FUNDPAYMENT: '/financial/fundPayment/exportPayments',
  //生成付款单--信用证
  CREATE_PAYMENT_FOR_CREDIT: '/financial/fundPayment/createPaymentForCredit',
  //批量提交
  SUBMIT: '/financial/paymentApply/batchSubmitToPayment',
  // 撤回
  WITHDRAW: '/financial/fundPayment/withdrawPayment',
  //批量过帐
  BATCH_VOUCHER: '/financial/fundPayment/batchSyncVoucher',
  //批量标记过帐
  BATCH_SIGN_VOUCHER: '/financial/fundPayment/batchSignSyncVoucher',
  //支付结果查询
  PAY_RESULT: '/financial/fundPayment/confirmPayResult',
  //确认支付前校验
  BEFORE_PAY: '/financial/fundPayment/beforeConfirmPay',
  //查询应付结算单
  PAYABLE_SETTLEMENT_PAGE: '/financial/payableSettlement/page',
};
